import { sbEditable } from '@storyblok/storyblok-editable'
import * as React from 'react'
import { Button } from '../../components/UI/Button'
import { renderRichtext } from '../../lib/utils/renderRichtext'
import {
  Block,
  BlockDescription,
  BlockHeadline,
  BlockImage,
  Body,
  Description,
  Header,
  Headline,
  Wrapper,
} from './styled'
import { useI18n } from '../../lib/context/i18n'

export const TextColumns = ({ blok }) => {
  const { getTranslatedUrlFromLink } = useI18n()
  return (
    <Wrapper {...sbEditable(blok)}>
      {(blok.headline || blok.description) && (
        <Header>
          <Headline>{blok.headline}</Headline>
          <Description className="prose">{renderRichtext(blok.description)}</Description>
        </Header>
      )}
      <Body>
        {blok.textBlocks.map(blok => {
          return (
            <Block {...sbEditable(blok)} key={blok._uid}>
              {blok.image.filename && (
                <BlockImage src={blok.image.filename} alt={blok.image.title ?? blok.image.name ?? blok.headline} />
              )}
              <div>
                {blok.headline && <BlockHeadline>{blok.headline}</BlockHeadline>}
                <BlockDescription hasButton={blok.link.length} className="prose">
                  {renderRichtext(blok.description)}
                </BlockDescription>
                {blok.link.length ? (
                  <Button
                    as="a"
                    $ignoreTheme
                    $size="small"
                    $variant="secondary"
                    children={blok.link[0].text}
                    href={getTranslatedUrlFromLink(blok.link[0].link)}
                  />
                ) : null}
              </div>
            </Block>
          )
        })}
      </Body>
    </Wrapper>
  )
}
